import React from "react";
import { MDXRenderer } from "gatsby-plugin-mdx";
import { MDXProvider } from "@mdx-js/react";
import { TextWrapperDiv } from "./elements";

const OutBoundA = (props) =>
  props.href && props.href.substr(0, 1) === "#" ? (
    <a {...props} />
  ) : (
    <a target="_blank" rel="noopener noreferrer" {...props} />
  );

const components = {
  a: OutBoundA,
};

const TextWrapper = ({ children }) => (
  <TextWrapperDiv>
    <div>
      <MDXProvider components={components}>
        <MDXRenderer>{children}</MDXRenderer>
      </MDXProvider>
    </div>
  </TextWrapperDiv>
);

export default TextWrapper;
